import { RamlServicesBaggage, RamlServicesBaggageFirstSegmentMain, ServiceStatusCodeType } from '@common/interfaces';
import { CurrentCartState } from '@common/store';
import { Bound, BoundFlightsInner, Traveler } from 'src/sdk-reservation';
import { TestData_PASSENGER as PASS } from '../passenger-test-data';
import { TestData_BOUND as BOUND } from '../bound-test-data';

export function getBaggageTestData(data: CurrentCartState): any {
  if (!data.data?.plan?.services) {
    return data;
  }
  data.data.cartId = 'CART_ID001';
  data.data.plan.services.baggage = {};
  data.data.plan.services.baggage.firstBaggage = {};
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5101'] = { isAvailable: true };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5102'] = { isAvailable: false };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5101'].isAvailable = true;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5101']['PASSENGER00101'] = PASSENGER1;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5101']['PASSENGER00102'] = PASSENGER2;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5101']['PASSENGER00103'] = PASSENGER3;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5102']['PASSENGER00201'] = PASSENGER3;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5103'] = { isAvailable: true };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5104'] = { isAvailable: true };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5104']['PASSENGER00101'] = PASSENGER1;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5105'] = { isAvailable: true };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5105']['PASSENGER00101'] = PASSENGER1;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106'] = { isAvailable: true };
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_1'] = PASSENGER_R01_M51_1;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_2'] = PASSENGER_R01_M51_2;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_3'] = PASSENGER_R01_M51_3;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_4'] = PASSENGER_R01_M51_4;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_5'] = PASSENGER_R01_M51_5;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_6'] = PASSENGER_R01_M51_6;
  data.data.plan.services.baggage.firstBaggage['BOUND_R01M5106']['TRAVELER_R01_M51_7'] = PASSENGER_R01_M51_7;

  if (data.data?.plan?.airOffer?.bounds) {
    data.data.plan.airOffer.bounds = [
      BOUND.bound1,
      BOUND.bound2,
      BOUND.bound3,
      BOUND.bound4,
      BOUND.bound5,
      BOUND.bound6,
    ];
  }
  if (data.data?.plan?.travelers) {
    data.data.plan.travelers = [
      PASS.TRAVELER1,
      PASS.TRAVELER2,
      PASS.TRAVELER3,
      PASS.TRAVELER_R01_M51_1,
      PASS.TRAVELER_R01_M51_2,
      PASS.TRAVELER_R01_M51_3,
      PASS.TRAVELER_R01_M51_4,
      PASS.TRAVELER_R01_M51_5,
      PASS.TRAVELER_R01_M51_6,
      PASS.TRAVELER_R01_M51_7,
    ];
  }
  return data;
}

export const DEFAULT_PASSENGER: RamlServicesBaggageFirstSegmentMain = {
  id: 'FBAG',
  serviceStatus: '',
  isAvailable: false,
  prices: {
    total: 500,
    currencyCode: 'JPY',
  },
  catalogue: {
    prices: {
      total: 20000,
      currencyCode: 'JPY',
    },
  },
};

export const PASSENGER1: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};

export const PASSENGER2: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
  serviceStatus: 'requested',
  prices: {
    total: 9000.99,
    currencyCode: 'USD',
  },
  catalogue: {
    prices: {
      total: 12345,
      currencyCode: 'JPY',
    },
  },
};

export const PASSENGER3: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
  serviceStatus: 'requested',
  prices: {
    total: 12000,
    currencyCode: 'JPY',
  },
  catalogue: {
    prices: {
      total: 12345,
      currencyCode: 'JPY',
    },
  },
};

export const PASSENGER_R01_M51_1: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
export const PASSENGER_R01_M51_2: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
export const PASSENGER_R01_M51_3: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
export const PASSENGER_R01_M51_4: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
export const PASSENGER_R01_M51_5: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
export const PASSENGER_R01_M51_6: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
  serviceStatus: 'requested',
};
export const PASSENGER_R01_M51_7: RamlServicesBaggageFirstSegmentMain = {
  ...DEFAULT_PASSENGER,
};
